/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 말풍선을 나의 대화로 설정하는 툴을 정의한다.
 *
 * @file /src/rootin/blocks/talk/tools/Me.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 9. 15.
 */
import { Tool } from '@rootin/base/Tool';
import { Block } from '@rootin/base/Block';
import { Element } from '@rootin/base/Element';
import { Balloon } from '@rootin/blocks/talk/blocks/Balloon';
import { Language, LanguageText } from '@utils/Language';

export class Me extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'talk-me';

    /**
     * 툴그룹
     */
    static group: string = 'talk-side';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-share"><g transform="matrix(-1 0 0 1 24 0)"><path d="M12 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4"/><path d="M16 3h6v6"/><path d="m16 9 6-6"/></g></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.talk.tools.me');

    /**
     * 툴 클릭시 실행할 핸들러를 정의한다.
     */
    handler(): void {
        const block = this.editor.focus.getBlock();
        if (block === null || block.getType() !== Balloon.type) {
            return;
        }

        const balloon = block as Balloon;
        if (balloon.side === 'me') {
            return;
        }

        const container = balloon.getParent();
        container?.onBeforeEdit();
        balloon.side = 'me';
        balloon.syncSide();
        container?.onEdit();
    }

    /**
     * 툴의 표시여부 조건을 설정한다.
     *
     * @param block - 커서가 위치한 블록
     * @param element - 커서가 위치한 편집유닛
     * @returns 표시여부
     */
    visible(block: Block | null, element: Element | null): boolean {
        return block?.getType() === Balloon.type;
    }

    /**
     * 툴이 활성여부 조건을 설정한다.
     *
     * @returns 활성여부
     */
    active(): boolean {
        const block = this.editor.focus.getBlock();
        return block !== null && block.getType() === Balloon.type && (block as Balloon).side === 'me';
    }
}
